module.exports = new __parcel__URL__("FEAST_FLEET.2fbdbd07.svg").toString();